import { useTranslation } from 'react-i18next';

export default function SalonSearchBar({ value, onChange, id = 'salon-search' }) {
  const { t } = useTranslation();
  return (
    <div className="salon-browser-search-wrap" style={{ position: 'relative', width: '100%' }}>
      <span
        style={{
          position: 'absolute',
          left: '1rem',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--text-muted)',
          fontSize: '1.1rem',
          pointerEvents: 'none',
        }}
        aria-hidden
      >
        🔍
      </span>
      <input
        id={id}
        type="search"
        autoComplete="off"
        placeholder={t('shops.searchPlaceholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="barber-input shops-search-input"
        style={{
          width: '100%',
          padding: '0.75rem 1.5rem 0.75rem 2.75rem',
          background: '#1a1a1a',
          border: '1px solid var(--border)',
          borderRadius: '8px',
          color: '#ffffff',
          fontFamily: "'Roboto', sans-serif",
          fontSize: '1rem',
          outline: 'none',
          transition: 'border-color 0.2s',
        }}
        onFocus={(e) => (e.target.style.borderColor = 'var(--orange)')}
        onBlur={(e) => (e.target.style.borderColor = 'var(--border)')}
      />
    </div>
  );
}
